/**
 * The message an author is shown for a rejected call: the error's own words, or the fallback when
 * it has none. A backend refusal is prose written for the author, so it is shown verbatim and never
 * parsed; only a failure that says nothing at all falls back to wording of our own.
 *
 * Kept here, with no imports of its own, so a store can use it without loading the request layer:
 * the stores hold the API through ports and types only.
 */
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const resolveErrorMessage = (error: unknown, fallback = GENERIC_ERROR_MESSAGE): string => (error instanceof Error && error.message ? error.message : fallback);
